import React from 'react';

const DoorIcon = ({ width = '20', height = '20', fill = 'none', ...props }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill={fill}
    {...props}
  >
    <g clipPath="url(#clip0_2642_1389)">
      <path
        d="M16.343 1.3623H2.90625V18.6381H16.343V1.3623Z"
        stroke="#222222"
        strokeWidth="1.91953"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5033 10.4798C12.376 10.4798 12.254 10.4292 12.164 10.3392C12.074 10.2492 12.0234 10.1272 12.0234 9.9999C12.0234 9.87263 12.074 9.75057 12.164 9.66057C12.254 9.57058 12.376 9.52002 12.5033 9.52002"
        stroke="#222222"
        strokeWidth="1.91953"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5039 10.4798C12.6312 10.4798 12.7532 10.4292 12.8432 10.3392C12.9332 10.2492 12.9838 10.1272 12.9838 9.9999C12.9838 9.87263 12.9332 9.75057 12.8432 9.66057C12.7532 9.57058 12.6312 9.52002 12.5039 9.52002"
        stroke="#222222"
        strokeWidth="1.91953"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2642_1389">
        <rect
          width="19.1953"
          height="19.1953"
          fill="white"
          transform="translate(0.0273438 0.402344)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default DoorIcon;
